import {Store, useStore} from "@tanstack/react-store";

export interface SettingsState {
  /**
   * When true, developer tooling overlays are rendered:
   *   - Theme Builder panel
   *   - TanStack Router Devtools
   *   - TanStack Query Devtools
   *
   * Toggled from the Settings page (`/_app/settings`).
   */
  isDevModeEnabled: boolean;

  /** Toggle dev mode on / off. */
  toggleDevMode: () => void;
}

/**
 * TanStack Store instance for settings state.
 * Created at module level — stable instance across renders.
 */
const settingsStore = new Store<SettingsState>({
  isDevModeEnabled: false,

  toggleDevMode: () => {
    settingsStore.setState((state) => ({
      ...state,
      isDevModeEnabled: !state.isDevModeEnabled,
    }));
  },
});

/**
 * React hook to access settings state with fine-grained subscriptions.
 * Only re-renders when the selected state slice changes.
 *
 * @example
 * const isDevModeEnabled = useSettingsStore((state) => state.isDevModeEnabled);
 */
export function useSettingsStore<T>(selector: (state: SettingsState) => T): T {
  return useStore(settingsStore, selector);
}
